import { useAppSelector } from '@user/store/hooks'
import { FEATURES } from '@sales-center/common/tenantFeatures'
import { selectTenantFeatureById } from '@user/store/tenantFeatures'

export function useFormPacketsEnabled() {
  const feature = useAppSelector((state) =>
    selectTenantFeatureById(state, FEATURES.FormPackets),
  )

  return feature?.enabled ?? false
}
